import { ModalService } from "@whatslly/ui-components/modals";

export const messagesModals = new ModalService();
